export default {
  state: {
    searchVisitedResumeList: [],
  },
  mutations: {
    addSearchVisitedResumeList (state, obj) {
      var index = state.searchVisitedResumeList.findIndex( i => i.resumeType == obj.resumeType && i.resumeId == obj.resumeId);
      if(index < 0){
        state.searchVisitedResumeList.push(obj);
      }
    }
  }
};